import { CollectionItem } from 'data/records'
import { resource, collection as c, findSelector } from 'data/helpers/apiv3'

const [api, actions] = resource(CollectionItem, [
  ['create', c.post('', ['collectionItem'])],
  ['list', c.get('', ['collectionId'])],
  c.post('reorder', ['collectionId', 'order']),
  c.post('batchAdd', ['collectionId', 'items']) // items : [{item_type, item_id}]
])

const selectors = {
  ...findSelector(CollectionItem),
  byCollectionId: (state, collectionId) => {
    return state.apiv3.collectionItem.id.filter(ci => ci.collectionId === collectionId).sortBy(i => i.position)
  }
}

const reducers = {}

const initialState = {}

export {
  api as collectionItemApi,
  actions as collectionItemActions,
  selectors as collectionItemSelectors,
  reducers as collectionItemReducers,
  initialState as collectionItemInitialState
}
